import { LAYERS } from '@/../shared-constants/map-constants';
import { generatePopupHtml } from '@/map/popup-maker';
import { signS3Url } from '@/utils/sign-s3-url';
import { SOURCES } from './map-constants';

// ! TODO: remove on refactor. Event management and popup creation should exist separately
export function displayPopupAndDoManyOtherThings(
  map,
  popup,
  evt,
  platformIcons
) {
  // query all the layers the mouse is on
  // if we find the cluster layers, don't display popups
  // the layer array, ['LAYERS.CLUSTER', 'LAYERS.CLUSTER2', 'LAYERS.PROPERTY_COUNT']
  // is the clusters layers
  // which we don't need popup when mouse is on
  const features = map.queryRenderedFeatures(evt.point, {
    layers: [LAYERS.CLUSTER, LAYERS.PROPERTY_COUNT],
  });
  if (features.length > 0) return;

  map.getCanvas().style.cursor = 'pointer'; // eslint-disable-line no-param-reassign
  const coordinates = evt.features[0].geometry.coordinates.slice();

  /** from docs, don't understand what it is */
  // Ensure that if the map is zoomed out such that multiple
  // copies of the feature are visible, the popup appears
  // over the copy being pointed to.
  while (Math.abs(evt.lngLat.lng - coordinates[0]) > 180) {
    coordinates[0] += evt.lngLat.lng > coordinates[0] ? 360 : -360;
  }

  // Populate the popup and set its coordinates
  // based on the feature found

  const rawFeatureData = evt.features[0].properties;
  // we need to parse json here bc mapbox will return stringified nested properties from its geojson
  const onlinePlatforms = JSON.parse(rawFeatureData.onlinePlatforms);
  const propertyDataJs = { ...rawFeatureData, onlinePlatforms };

  generatePopupHtml(map, propertyDataJs, coordinates, popup, platformIcons);

  signS3Url(propertyDataJs.coverImageUrl).then((url) => {
    const img = document.getElementById(
      `${propertyDataJs.deckardid}-popup-img`
    );
    // ! user might hover off the dot before the signed url is ready
    // ! do not remove it
    if (img) {
      img.src = url;
    }
  });
}

// TODO: Belongs to property list layer
export function addPropertyMouseEffects(map, onDotClick, platformIcons) {
  const layerId = LAYERS.PROPERTY_LIST;
  const sourceId = SOURCES.PROPERTY_LIST;
  // Create a popup , but don't add it to the map yet.
  let popupOnHover = null;
  let geoJsonId = null;

  map.on('mouseenter', layerId, (evt) => {
    popupOnHover = new window.mapboxgl.Popup({
      closeButton: false,
      offset: 10,
    });
    const popup = popupOnHover;
    displayPopupAndDoManyOtherThings(map, popup, evt, platformIcons);

    geoJsonId = evt.features[0].id;

    map.setFeatureState(
      {
        source: sourceId,
        id: geoJsonId,
      },
      {
        hover: true,
      }
    );
  });

  map.on('mouseleave', layerId, () => {
    if (geoJsonId && geoJsonId !== 0) {
      map.removeFeatureState({
        source: sourceId,
        id: geoJsonId,
      });
    }
    map.getCanvas().style.cursor = 'grab'; // eslint-disable-line no-param-reassign
    if (popupOnHover && popupOnHover.isOpen()) {
      popupOnHover.remove();
      popupOnHover = null;
    }
  });

  map.on('click', layerId, (evt) => {
    if (popupOnHover && popupOnHover.isOpen()) {
      popupOnHover.remove();
      popupOnHover = null;
    }
    // to detect whether the user is clicking the cluster or the count
    const features1 = map.queryRenderedFeatures(evt.point, {
      layers: [LAYERS.CLUSTER, LAYERS.PROPERTY_COUNT],
    });
    if (features1.length > 0) return;

    // to detect whether the user is clicking an individual property
    const features2 = map.queryRenderedFeatures(evt.point, {
      layers: [LAYERS.PROPERTY_LIST],
    });
    const { deckardid } = features2[0].properties;

    // this function triggers the modal
    onDotClick(deckardid);
  });
}
